// fundsTable.js
import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import './fundsTable.css';
import "../../common/css/protagonistMUIDatatable.css";
import "../../common/css/icons.css";
import { TableCell, IconButton, Snackbar } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { DeleteFund } from '../../common/api/FundAPIHelper';


const FundsTable = ({ data, onEdit, onDelete }) => {
  console.log(data);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleDelete = async (fundId) => {
    const confirmed = window.confirm('Are you sure you want to delete the fund?');
    if (confirmed) {
      const response = await DeleteFund(fundId);
      if (response && response.status === 200) {
        setSnackbarMessage(`Successfully deleted fund with ID ${fundId}`);
        onDelete(); // Call the onDelete function after successful deletion
      } else {
        console.error('Error:', response.status, response.statusText);
        setSnackbarMessage(`Failed to delete fund with ID ${fundId}`);
      }
      setSnackbarOpen(true);
    }
  };

  const handleEdit = (fundId) => {
    const fund = data.find(fund => fund.internal_fund_id === fundId);  // Fetch the whole fund object
    onEdit(fund); // Pass the fund object to the onEdit callback
};


  const customFundIdRender = (value, tableMeta, updateValue) => {
    const fundId = value;
    const handleDeleteClick = () => handleDelete(fundId);
    const handleEditClick = () => handleEdit(fundId, tableMeta.rowData); // Pass the row data when the edit button is clicked

    return (
      <div>
        <IconButton onClick={handleEditClick}>
          <FontAwesomeIcon icon={faPen} className="ra__protMUIDatatable_icon" /> {/* Edit icon */}
        </IconButton>
        <IconButton onClick={handleDeleteClick}>
          <FontAwesomeIcon icon={faTrashAlt} className="ra__protMUIDatatable_icon" /> {/* Delete icon */}
        </IconButton>
      </div>
    );
  };

  if (!data) {
    return <div>No data available.</div>;
  }
    const customHeadRender = ({ label }) => {
        return (
          <TableCell style={{ textTransform: 'capitalize' }}>
            {label}
          </TableCell>
        );
      };

      function formatCurrency(value) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value);
      }

    const columns = [
      { name: 'internal_fund_id', 
        label: 'Edit / Delete',
          options: {
              customHeadRender: customHeadRender,
              customBodyRender: customFundIdRender,
          },
      },
        { name: 'internal_fund_id', 
          label: 'Fund Id',
            options: {
                customHeadRender: customHeadRender,
            },
        },
        { name: 'fund_name', 
          label: 'Fund Name',
            options: {
                customHeadRender: customHeadRender,
            },
        },
        { name: 'target_aum', 
          label: 'Target Assets Under Management (AUM)',
            options: {
                customHeadRender: customHeadRender,
                customBodyRender: (value) => {
                    return formatCurrency(value);
                  },
            },
        },
        {
          name: 'current_aum',
          label: 'Current Assets Under Management (AUM)',
          options: {
            customHeadRender: customHeadRender,
            customBodyRender: (value) => {
                return formatCurrency(value);
              },
          },
        },
        {
            name: 'total_investments_in_fund',
            label: 'Total Invested',
            options: {
              customHeadRender: customHeadRender,
              customBodyRender: (value) => {
                  return formatCurrency(value);
                },
            },
          },
          {
            name: 'available_dry_powder',
            label: 'Available Dry Powder',
            options: {
              customHeadRender: customHeadRender,
              customBodyRender: (value) => {
                  return formatCurrency(value);
                },
            },
          },
      ];

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'standard',
    serverSide: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15],
    selectableRows: 'none',
    expandableRows: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    customToolbarSelect: () => {},
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'medium',
      };
    },
    textLabels: {
      body: {
        noMatch: 'Sorry, no matching records found',
      },
    },
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage('');
  };

  return (
    <div>
      <MUIDataTable
        title={'Funds'}
        data={data}
        columns={columns}
        options={options}
        className="protMUIDatatable"
        style={{ width: '90%' }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        className={snackbarMessage.includes('Successfully') ? '.ra__protMUIDatatable_snackbar' : '.ra__protMUIDatatable_snackbar error'}
      />
    </div>
  );
};

export default FundsTable;
